import React from 'react';
import { Card } from 'react-bootstrap';
import { FaEdit, FaTrash } from 'react-icons/fa';
import GlobalButton from '../../../utils/GlobalButton';
import dashboard from '../../../css/dashboard.module.css'
import { useNavigate } from 'react-router-dom';
import { formatDate } from '../../shared/Constant';
import { CiSettings } from "react-icons/ci";


const Cards = ({id,name,title,createdDate,modifiedDate,showAction=false,showFooter=false,navigateeditIcon,navigatedBotConfig="",handleDelete=null,handlePublish=null,tabValue="all",stopLiveBots,startLiveBots,handleRepublish}) => {
     const navigate = useNavigate();

     
  return (
    <Card border="light" className="mb-3 shadow-sm w-100 " >
      {/* Header */}
      <Card.Header className="d-flex justify-content-between align-items-center">
        <span className="fw-bold">{name}</span>
         <div>
       {showAction && tabValue==="all" && 
        <CiSettings role="button" className='me-3' size={20} onClick={()=>{
          if(navigatedBotConfig){
            navigate(navigatedBotConfig)
          }
        }}/>

}
<FaEdit className="me-3 text-primary" role="button"  onClick={() => {
if (navigateeditIcon) {
navigate(navigateeditIcon);
}
}}/>
<FaTrash className="text-danger" role="button" onClick={() => handleDelete(id)} />
</div>
      </Card.Header>

      {/* Body */}
      <Card.Body >
        <Card.Text >
         {title}
        </Card.Text>
        <div className='text-muted small'>
            <div>Last Edited By: <span className={`fw-medium ${dashboard.datefont}`} >{formatDate(modifiedDate)}</span></div>
            <div>Creation Date: <span className={`fw-medium ${dashboard.datefont}`}>{formatDate(createdDate)}</span></div>
        </div>
      </Card.Body>

      {/* Footer */}
      {showFooter &&
      <Card.Footer className="d-flex justify-content-end bg-white border-top-0">
         <GlobalButton children={"Publish"}  size="sm" className={`${dashboard.backgroundColor} ${dashboard.nohover}`}
          variant="contained"
          onClick={() =>handlePublish(id,name,title)}
        />
      </Card.Footer>
      }
    </Card>
    
  );
};

export default Cards;
